'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const find = require('lodash.find');
const ContextComponent = require('../ContextComponent');
const style = require('./ConnectBoardModal-style.scss');

// Components
const Select = require('react-select');
const CloseIcon = require('dibs-vg/dist/react/close');
const Modal = require('../Modal');
const SanitizeHtml = require('../SanitizeHtml');

// Actions
const pinterestActions = require('../../actions/pinterestActions');

class ConnectBoardModal extends ContextComponent {

    constructor(props) {
        super(props);

        this._onBoardChange = this._onBoardChange.bind(this);
        this._doneClick = this._doneClick.bind(this);
        this._close = this._close.bind(this);

        this.state = {
            boardChanged: false,
            boardId: 'default',
            boardName: this._getDefaultBoardName()
        };
    }

    componentWillReceiveProps(nextProps) {
        const {isOpen} = this.props;
        const {boardChanged} = this.state;
        let {boardId} = this.state;

        if (!isOpen && nextProps.isOpen) {
            boardId = 'default';
            this.setState({boardId, boardChanged: false});
        }

        const {connectedBoard} = this.props;
        const defaultBoard = this._findDefaultBoard(nextProps);
        let connectedId = 'default';
        let boardName = this._getDefaultBoardName();

        if (connectedBoard) {
            connectedId = connectedBoard.id;
            boardName = connectedBoard.name;
        } else if (defaultBoard) {
            connectedId = defaultBoard.id;
        }

        if (!boardChanged) {
            this.setState({
                boardId: connectedId,
                boardName: boardName
            });
        }
    }

    _getDefaultBoardName() {
        const {copy: {defaultBoardName}} = this.props;
        return defaultBoardName;
    }

    _findDefaultBoard(props) {
        const {boards} = props || this.props;
        const defaultBoard = find(boards, board => {
            return board.name === this._getDefaultBoardName();
        });

        return defaultBoard;
    }

    _close(event) {
        const {connectedBoard} = this.props;
        event.preventDefault();

        if (connectedBoard) {
            this.context.executeAction(pinterestActions.hideConnectBoardModal);
        } else {
            this._saveBoard();
        }
    }

    _doneClick() {
        const {boardName} = this.state;
        const {connectedBoard, tracking} = this.props;

        this._saveBoard();

        if (
            connectedBoard && boardName === connectedBoard.name ||
            !connectedBoard && boardName === this._getDefaultBoardName()
        ) {
            this.context.executeAction(pinterestActions.track, tracking.boardUnchanged);
        } else {
            this.context.executeAction(pinterestActions.track, tracking.boardUpdated);
        }
    }

    _onBoardChange(selectedItems) {
        const {name, id} = selectedItems;
        const boardChanged = true;
        this.setState({boardId: id, boardName: name, boardChanged});
    }

    _saveBoard() {
        const {boardId: id} = this.state;

        if (id === 'default') {
            this._saveDefaultBoard();
        } else {
            this.context.executeAction(pinterestActions.connectBoard, {id});
        }
    }

    _saveDefaultBoard() {
        this.context.executeAction(pinterestActions.createAndConnectBoard, {
            name: this._getDefaultBoardName()
        });
    }

    /**
     * Gets pinterest boards and checks if default board name is among saved boards,
     * if not then ushifts (puts default board name to first array position) boards array
     * with default board data
     * @return {Array} pinterest boards
     */
    _getBoards() {
        const {boards} = this.props;
        const boardsCopy = boards.slice(0);
        const defaultBoardName = this._getDefaultBoardName();

        if (boardsCopy.length) {
            const defaultBoard = this._findDefaultBoard();

            if (!defaultBoard) {
                boardsCopy.unshift({
                    id: 'default',
                    name: defaultBoardName
                });
            }
        }

        return boardsCopy;
    }

    render() {
        const {isOpen, copy, error} = this.props;
        const {boardId} = this.state;
        let errorMessage = null;

        if (error) {
            errorMessage = (
                <div className={style.error}>
                    <SanitizeHtml content={copy.boardConflict} />
                </div>
            );
        }

        return (
            <Modal isOpen={isOpen}
                className={style.modal}
                overlayClassName={style.overlay}
                canClose={false}>
                <div className="modal-inner-content">
                    <div className="modal-header">
                        {copy.header}
                    </div>
                    <div className="modal-body">
                        <div className="modal-simple-message">
                            <SanitizeHtml content={copy.message} />
                        </div>

                        {errorMessage}

                        <label className={style.fieldLabel}>Board Name</label>
                        <div className={style.fieldInput}>
                            <Select name="board"
                                onChange={this._onBoardChange}
                                searchable={false}
                                clearable={false}
                                value={boardId}
                                labelKey="name"
                                valueKey="id"
                                options={this._getBoards()} />
                        </div>

                        <div className={style.fieldSubHeader}>
                            <SanitizeHtml content={copy.hint} />
                        </div>

                        <button onClick={this._doneClick} className={`${style.button} button button-medium button-primary`}>
                            {copy.cta}
                        </button>
                    </div>
                </div>
                <div className="modal-close">
                    <a onClick={this._close} className="modal-close-btn" href="">
                        <CloseIcon className={style.close} />
                    </a>
                </div>
            </Modal>
        );
    }

}

ConnectBoardModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    connectedBoard: PropTypes.object,
    boards: PropTypes.array.isRequired,
    copy: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object
    })
};

module.exports = ConnectBoardModal;



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/ConnectBoardModal.jsx